import React from 'react';

// Delivery roster: list, add, edit, pause/activate, delete. All state and
// handlers come from useDelivery — this component is presentation only.
const DeliveryTab = ({ delivery }) => {
  const {
    deliveryPersons, openAddDeliveryPerson,
    handleEditDeliveryPerson, handleToggleDeliveryPersonStatus, handleDeleteDeliveryPerson,
  } = delivery;

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-display text-2xl text-ink">Delivery Persons</h2>
          <p className="text-sm text-ink-soft mt-1">Manage your delivery roster and availability.</p>
        </div>
        <button
          onClick={openAddDeliveryPerson}
          className="bg-accent text-paper px-4 py-2.5 rounded-full hover:bg-accent-deep transition-colors dpc-label text-xs"
        >
          Add Delivery Person
        </button>
      </div>

      {deliveryPersons.length === 0 ? (
        <div className="bg-surface border border-line rounded-md p-10 text-center text-ink-soft">
          No delivery persons yet. Add one to get started.
        </div>
      ) : (
        <div className="bg-surface border border-line rounded-md overflow-hidden">
          <table className="min-w-full divide-y divide-line">
            <thead className="bg-paper">
              <tr>
                <th className="px-6 py-3 text-left dpc-label text-ink-faint">Name</th>
                <th className="px-6 py-3 text-left dpc-label text-ink-faint">Contact</th>
                <th className="px-6 py-3 text-left dpc-label text-ink-faint">Vehicle</th>
                <th className="px-6 py-3 text-left dpc-label text-ink-faint">Status</th>
                <th className="px-6 py-3 text-right dpc-label text-ink-faint">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {deliveryPersons.map((person) => (
                <tr key={person.id}>
                  <td className="px-6 py-4 text-sm text-ink font-medium">{person.fullName}</td>
                  <td className="px-6 py-4 text-sm text-ink-soft">
                    <div>{person.phone}</div>
                    {person.email && <div className="text-ink-faint">{person.email}</div>}
                  </td>
                  <td className="px-6 py-4 text-sm text-ink-soft">
                    {person.vehicleType || '—'}{person.vehicleNumber ? ` · ${person.vehicleNumber}` : ''}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${
                      person.isActive ? 'bg-accent-soft text-accent-deep' : 'bg-paper text-ink-faint'
                    }`}>
                      {person.isActive ? 'Active' : 'Paused'}
                    </span>
                    {person.isAvailable === false && (
                      <span className="ml-2 inline-flex px-2.5 py-1 rounded-full text-xs font-semibold bg-brass/10 text-brass-deep">
                        Unavailable
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 text-right text-sm space-x-3 whitespace-nowrap">
                    <button onClick={() => handleEditDeliveryPerson(person)} className="text-accent hover:text-accent-deep font-medium">
                      Edit
                    </button>
                    <button onClick={() => handleToggleDeliveryPersonStatus(person.id, person.isActive)} className="text-ink-soft hover:text-ink font-medium">
                      {person.isActive ? 'Pause' : 'Activate'}
                    </button>
                    <button onClick={() => handleDeleteDeliveryPerson(person.id)} className="text-accent-deep hover:text-ink font-medium">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveryTab;
